import React from "react";

import Header from "../Header/productheader";

import { useCart } from "../Context/cartcontext";
import {
  handleAddToWishlist,
  handleAddToCart,
  handleRemoveFromWishlist,
} from "../reducer/Cart/cart.actions";
import { BsHandbagFill } from "react-icons/bs";

import { isPresentHelper } from "../utils/isPresent";

const features = [
  {
    name: "Free shipping",
    description: "Free shipping will be done anywhere in India",
    icon: BsHandbagFill,
  },
  {
    name: "No hidden fees",
    description:
      "Unlike gift cards there are no hidden fees or handling charges.",
    icon: BsHandbagFill,
  },
];

const Productdetails = ({ product }) => {
  const { cartState, dispatchToCart } = useCart();
  const isProductAddedToWishlist = isPresentHelper(cartState.wishlist, product);

  return (
    <div>
      <Header />
      <div className="flex items-start justify-between bg-gray-100 lg:h-fit  md:h-fit  sm:justify-center  sm:h-h-fit">
        <div className="item-start justify-start sm:w-[50%] sm:h-[50%] ">
          <img className="lg:h-[80vh]" src={product?.image} alt="product" />
        </div>
        <div className="h-4/5 w-2/4 ml-16 text-left p-10 justify-between ">
          <h1 className="font-bold text-xl sm:text-2xl mb-8">
            {product?.name}
          </h1>
          <div className="mb-8">{product?.description}</div>
          <div className="flex flex-col justify-items-center font-bold text-3xl mt-4 mb-2">
            ₹ {product?.price}
            <div className="flex mt-2">
              <span className="font-bold opacity-60 line-through ml-2 text-lg">
                ₹ {product?.price}
              </span>
              <span className="font-bold opacity-60 ml-2 text-lg">
                (32% OFF)
              </span>
            </div>
          </div>
          <br />
          <div className="space-x-3">
            <button
              className="py-2 px-3 inline-block bg-gray-900 text-white  hover:bg-black hover:text-green-50 font-bold rounded-md mt-1 mb-2 focus:outline-none"
              onClick={() =>
                isProductAddedToWishlist
                  ? dispatchToCart(handleRemoveFromWishlist(product))
                  : dispatchToCart(handleAddToWishlist(product))
              }
            >
              Add to wishlist
            </button>
            <button
              className="py-2 px-3 bg-gray-900 text-white  hover:bg-black hover:text-green-50 font-bold rounded-md mt-1 mb-2 focus:outline-none"
              onClick={() => dispatchToCart(handleAddToCart(product))}
            >
              Add to Cart
            </button>
          </div>
          <div className="hidden md:block  sm:block ">
            <div className="mt-10">
              <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                {features.map((feature) => (
                  <div key={feature.name} className="relative">
                    <dt>
                      <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-yellow-500 text-white">
                        <feature.icon className="h-6 w-6" />
                      </div>
                      <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                        {feature.name}
                      </p>
                    </dt>
                    <dd className="mt-2 ml-16 text-base text-gray-500 ">
                      {feature.description}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Productdetails;
